<template>
  <main class="page" v-if="user.id !== undefined">
    <AppBack></AppBack>
    <section class="section page__header">
          <h1 class="title" v-if="user.id === currentUser.id">Изменить личные данные</h1>
          <h1 class="title" v-else>Изменить данные сотрудника</h1>
    </section>
    <div class="form__bg">
      <section class="section">
          <AppInputAvatar
            :avatar="user.avatar"
            title="Фото сотрудника"
            tip="Файл в формате .jpg или .png"
            @value-changed="updateAvatar"
            :disabled="!roleAccessUpdate && !roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
          />
          <h2 class="subtitle" style="margin-top: 32px">Учетные данные сотрудника</h2>
          <div class="form__inputs">
            <AppInput title="E-mail"
                      :value="user.email"
                      required
                      :valid="{}"
                      @value-changed="updateEmail"
                      :disabled="!roleAccessUpdate"
            />
            <AppInput title="Телефон"
                      :value="user.phone"
                      required
                      :valid="{}"
                      @value-changed="updatePhone"
                      :disabled="!roleAccessUpdate"
            />
            <AppInput v-if="roleAccessPasswordUpdate"
                      title="Новый пароль"
                      is-password
                      :value="user.password"
                      :valid="userValidation.password"
                      @value-changed="updatePassword"
                      :disabled="!roleAccessUpdate"
                      @got-focus="clearValidation('password')"
            />
            <AppSelectMultiple v-if="roleAccessExtendedInfo"
                               title="Роли сотрудника"
                               placeholder="Выберите роли сотрудника"
                               required
                               :value="user.roles"
                               :options="usersRoleOptions"
                               :allow-epty="false"
                               @add-item="addRole"
                               @remove-item="removeRole"
            />
          </div>
          <h2 class="subtitle">Основная информация</h2>
          <div class="form__inputs">
            <AppInput title="Имя"
                      :value="user.profile.name"
                      :valid="{}"
                      @value-changed="updateName"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInput title="Фамилия"
                      :value="user.profile.surname"
                      :valid="{}"
                      @value-changed="updateSurname"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInput title="Отчество"
                      :value="user.profile.patronymic"
                      :valid="{}"
                      @value-changed="updatePatronymic"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInputDate title="Дата рождения"
                          :value="currentBirthDate"
                          type="single"
                          :valid="{}"
                          @value-changed="updateBirthDate"
                          :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInput v-if="roleAccessExtendedInfo"
                      title="Место рождения"
                      :value="user.profile.birth_place"
                      :valid="{}"
                      @value-changed="updateBirthPlace"
            />
          </div>
          <h2 class="subtitle">Контакты</h2>
          <div class="form__inputs">
            <AppInput title="Корпоративный телефон"
                      :value="user.profile.corp_phone"
                      :valid="{}"
                      @value-changed="updateCorpPhone"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInput title="Рабочий телефон"
                      :value="user.profile.work_phone"
                      :valid="{}"
                      @value-changed="updateWorkPhone"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppInput title="Добавочный номер"
                      :value="user.profile.work_phone_append"
                      :valid="{}"
                      @value-changed="updateWorkPhoneAppend"
                      :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"
            />
            <AppCheckbox title="Трудоустроен официально"
                         :checked="Boolean(user.profile.is_official)"
                         @toggle-check="updateOfficialFlag"
                         :disabled="!roleAccessUpdate"
            />
        </div>
        <h2 class="subtitle">Рабочая информация</h2>
        <div class="form__inputs">
          <AppSelect title="Статус"
                     placeholder="Укажите статус"
                     :value="currentStatus"
                     :options="statusList"
                     @value-changed="updateStatus"
                     :disabled="!roleAccessUpdate"
          />
          <AppSelect title="График работы"
                     placeholder="Укажите график работы"
                     :value="currentSchedule"
                     :options="scheduleList"
                     @value-changed="updateSchedule"
                     :disabled="!roleAccessUpdate"
          />
          <AppSelect title="Подразделение"
                     placeholder="Укажите подразделение"
                     :value="currentDepartment"
                     :options="departmentList"
                     @value-changed="updateDepartment"
                     :disabled="!roleAccessUpdate"
          />
          <AppSelect title="Должность"
                     placeholder="Укажите должность"
                     :value="currentPosition"
                     :options="positionList"
                     @value-changed="updatePosition"
                     :disabled="!roleAccessUpdate"
          />
          <AppSelect title="Вид занятости"
                     placeholder="Укажите вид занятости"
                     :value="currentEmployment"
                     :options="employmentList"
                     @value-changed="updateEmployment"
                     :disabled="!roleAccessUpdate"
          />
          <AppInputDate title="Дата приема"
                        :value="user.profile.employment_at"
                        type="single"
                        :valid="{}"
                        @value-changed="updateEmploymentDate"
                        :disabled="!roleAccessUpdate"
          />
        </div>
        <!--ОК и бухгалтерия-->
        <h2 v-if="roleAccessExtendedInfo" class="subtitle">Документы</h2>
        <div class="form__inputs">
          <AppInput title="ИНН"
                    :value="user.profile.inn"
                    :valid="{}"
                    @value-changed="updateInn"
          />
          <AppInput title="СНИЛС"
                    :value="user.profile.snils"
                    :valid="{}"
                    @value-changed="updateSnils"
          />

        </div>
        <div class="page__row flex-wrap">
            <div class="user-card" v-for="document in  user.documents" :key="document.id">
              <div class="user-card__info">
                {{ document.type.name }}
              </div>
              <div class="user-card__button-wrap">
                <div class="user-card__button">
                  <AppButtonSmEdit @click.native="showDocumentUpdateModal(document)"/>
                </div>
                <div class="user-card__button">
                  <AppButtonSmRemove @click.native="removeDocument(document.id)"/>
                </div>
              </div>
            </div>
            <div class="user-card card-button" @click.stop="showDocumentCreateModal">
              <div class="card-button__icon">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 0L6 12" stroke="white" stroke-width="2"/>
                  <path d="M12 6L2.68221e-07 6" stroke="white" stroke-width="2"/>
                </svg>
              </div>
              <div class="card-button__text">
                Добавить документ
              </div>
            </div>
          </div>
        <h2 class="subtitle">Образование</h2>
        <div class="page__row flex-wrap">
          <div class="user-card" v-for="education in  user.educations" :key="education.id">
            <div class="user-card__info">
              {{ education.type.name }}
            </div>
            <div class="user-card__button-wrap">
              <div class="user-card__button">
                <AppButtonSmEdit @click.native="showEducationUpdateModal(education)"/>
              </div>
              <div class="user-card__button">
                <AppButtonSmRemove @click.native="removeEducation(education.id)"/>
              </div>
            </div>
          </div>
          <div class="user-card card-button" @click.stop="showEducationCreateModal">
            <div class="card-button__icon">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0L6 12" stroke="white" stroke-width="2"/>
                <path d="M12 6L2.68221e-07 6" stroke="white" stroke-width="2"/>
              </svg>
            </div>
            <div class="card-button__text">
              Добавить образование
            </div>
          </div>
        </div>
        <h2 class="subtitle">Семья</h2>
        <div class="page__row flex-wrap">
            <div class="user-card" v-for="member in  user.families" :key="member.id">
              <div class="user-card__info">
                {{ member.kinship.name }}<br v-if="member.kinship">
                {{ member.name }}
              </div>
              <div class="user-card__button-wrap">
                <div class="user-card__button">
                  <AppButtonSmEdit @click.native="showFamilyMemberUpdateModal(member)"/>
                </div>
                <div class="user-card__button">
                  <AppButtonSmRemove @click.native="removeFamilyMember(member.id)"/>
                </div>
              </div>
            </div>
            <div class="user-card card-button" @click.stop="showFamilyMemberCreateModal">
              <div class="card-button__icon">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 0L6 12" stroke="white" stroke-width="2"/>
                  <path d="M12 6L2.68221e-07 6" stroke="white" stroke-width="2"/>
                </svg>
              </div>
              <div class="card-button__text">
                Добавить члена семьи
              </div>
            </div>
          </div>
      </section>

      <section class="section" style="margin-top: 32px">
        <div class="page__buttons">
          <div class="page__item">
            <AppButton title="Сохранить" type="main" @click.native="updateUserInfo"
                       :disabled="!roleAccessUpdate && !(!roleAccessUpdate && user.id === currentUser.id)"/>
          </div>
          <div class="page__item">
            <AppButton title="Отмена" type="alt" @click.native="goBack"/>
          </div>
        </div>
      </section>

      <transition name="fade">
        <AppModal v-if="modalActive.success"
                  title="Информация о сотруднике обновлена!"
                  confirm-button-type="main"
                  confirm-button-title="ОК"
                  @confirm="leavePage"
        />
        <AppModal v-if="modalActive.error"
                  title="Ошибка!"
                  text="Вернутся к редактированию сотрудника"
                  confirm-button-type="main"
                  confirm-button-title="ОК"
                  @confirm="closeModal"
        />
        <UserFamiliesUpdateModal v-if="familyMemberUpdateModal.active"
                                 :member="familyMemberUpdateModal.member"
                                 @close-modal="closeFamilyMemberUpdateModal"
        />
        <UserFamiliesCreateModal v-if="familyMemberCreateModal.active"
                                 :new-member="familyMemberCreateModal.member"
                                 @close-modal="closeFamilyMemberCreateModal"
        />
        <UserDocumentUpdateModal v-if="documentUpdateModal.active"
                                 :document="documentUpdateModal.document"
                                 @close-modal="closeDocumentUpdateModal"
        />
        <UserDocumentCreateModal v-if="documentCreateModal.active"
                                 :new-document="documentCreateModal.document"
                                 @close-modal="closeDocumentCreateModal"
        />
        <UserEducationUpdateModal v-if="educationUpdateModal.active"
                                  :education="educationUpdateModal.education"
                                  @close-modal="closeEducationUpdateModal"
        />
        <UserEducationCreateModal v-if="educationCreateModal.active"
                                  :new-education="educationCreateModal.education"
                                  @close-modal="closeEducationCreateModal"
        />
      </transition>
      <ThePagePreloader v-if="isLoading"/>
    </div>
  </main>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppButton from '@/components/page/button/AppButton'
import AppInputAvatar from '@/components/page/input/AppInputAvatar'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppModal from '@/components/page/modal/AppModal'
import AppSelect from '@/components/page/input/AppSelect'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import UserFamiliesUpdateModal from '@/components/page/modal/UserFamiliesUpdateModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import UserFamiliesCreateModal from '@/components/page/modal/UserFamiliesCreateModal'
import UserDocumentUpdateModal from '@/components/page/modal/UserDocumentUpdateModal'
import UserDocumentCreateModal from '@/components/page/modal/UserDocumentCreateModal'
import UserEducationUpdateModal from '@/components/page/modal/UserEducationUpdateModal'
import UserEducationCreateModal from '@/components/page/modal/UserEducationCreateModal'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppSelectMultiple from '@/components/page/input/AppSelectMultiple'
import { mapGetters } from 'vuex'
import AppBack from '../../components/page/AppBack'

export default {
  components: {
    AppSelectMultiple,
    AppCheckbox,
    UserEducationCreateModal,
    UserEducationUpdateModal,
    UserDocumentCreateModal,
    UserDocumentUpdateModal,
    UserFamiliesCreateModal,
    AppButtonSmRemove,
    UserFamiliesUpdateModal,
    AppButtonSmEdit,
    ThePagePreloader,
    AppSelect,
    AppModal,
    AppInputDate,
    AppInputAvatar,
    AppButton,
    AppInput,
    AppBack
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      usersRoleOptions: '[dictionaries] usersRoleList',
      statusList: '[dictionaries] usersStatusList',
      departmentList: '[dictionaries] usersDepartmentList',
      positionList: '[dictionaries] usersPositionList',
      employmentList: '[dictionaries] usersEmploymentList',
      scheduleList: '[dictionaries] usersScheduleList'
    }),
    user () {
      // это свойство вычисляется два раза при маунте компонента.
      // при обновлении страницы сначала получает undefined,
      // выводит ошибку в консоль, так как компоненты не могу получить в props данные
      // затем получает данные из стора и все компоненты рендерятся как положено,
      // решил проблему через условный рендеринг обертки компонентов
      return this.$store.getters.userForUpdate
    },
    userValidation () {
      return this.$store.getters.userUpdateValidation
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessExtendedInfo () {
      return this.$store.getters.getRoleRightsUsers.extendedInfo
    },
    roleAccessPasswordUpdate () {
      return this.$store.getters.getRoleRightsUsers.password
    },
    roleAccessUpdate () {
      return this.$store.getters.getRoleRightsUsers.actions.update
    },
    currentStatus () {
      const userStatusId = this.$store.getters.userForUpdate.status ? this.$store.getters.userForUpdate.status.id : null
      const userStatusName = this.$store.getters.userForUpdate.status ? this.$store.getters.userForUpdate.status.name : 'Не определен'
      return {
        id: userStatusId,
        name: userStatusName
      }
    },
    currentBirthDate () {
      // ставим дату по умолчанию, если пустая строка, так как при получении данных в user-update-page.js
      // происходит проверка на null если даты нет, и во время редактирования (если дата не была изменена)
      // отправляется пустое значение
      return this.user.profile.birth_at !== '' ? this.user.profile.birth_at : '1800-01-01'
    },
    currentDepartment () {
      const userDepId = this.$store.getters.userForUpdate.department ? this.$store.getters.userForUpdate.department.id : null
      const userDepName = this.$store.getters.userForUpdate.department ? this.$store.getters.userForUpdate.department.name : 'Не определен'
      return {
        id: userDepId,
        name: userDepName
      }
    },
    currentPosition () {
      const userPosId = this.$store.getters.userForUpdate.position ? this.$store.getters.userForUpdate.position.id : null
      const userPosName = this.$store.getters.userForUpdate.position ? this.$store.getters.userForUpdate.position.name : 'Не определена'
      return {
        id: userPosId,
        name: userPosName
      }
    },
    currentEmployment () {
      const userEmpId = this.$store.getters.userForUpdate.employment ? this.$store.getters.userForUpdate.employment.id : null
      const userEmpName = this.$store.getters.userForUpdate.employment ? this.$store.getters.userForUpdate.employment.name : 'Не определен'
      return {
        id: userEmpId,
        name: userEmpName
      }
    },
    currentSchedule () {
      const userScheduleId = this.$store.getters.userForUpdate.schedule ? this.$store.getters.userForUpdate.schedule.id : null
      const userScheduleName = this.$store.getters.userForUpdate.schedule ? this.$store.getters.userForUpdate.schedule.name : 'Не определен'
      return {
        id: userScheduleId,
        name: userScheduleName
      }
    },
    modalActive () {
      return this.$store.getters.userUpdatePageModals
    },
    familyMemberUpdateModal () {
      return this.$store.getters.userFamilyMemberUpdateModal
    },
    familyMemberCreateModal () {
      return this.$store.getters.userFamilyMemberCreateModal
    },
    documentUpdateModal () {
      return this.$store.getters.userDocumentUpdateModal
    },
    documentCreateModal () {
      return this.$store.getters.userDocumentCreateModal
    },
    educationUpdateModal () {
      return this.$store.getters.userEducationUpdateModal
    },
    educationCreateModal () {
      return this.$store.getters.userEducationCreateModal
    },
    isLoading () {
      return this.$store.getters.userUpdateIsLoading
    }
  },
  methods: {
    clearValidation (value) {
      this.$store.commit('[userUpdate] CLEAR_USER_VALIDATION', value)
    },
    loadOptions () {
      this.$store.dispatch('[dictionaries] getRoleList')
      this.$store.dispatch('[dictionaries] getStatusList')
      this.$store.dispatch('[dictionaries] getDepartmentList')
      this.$store.dispatch('[dictionaries] getPositionList')
      this.$store.dispatch('[dictionaries] getEmploymentList')
      this.$store.dispatch('[dictionaries] getScheduleList')
    },
    updateUserInfo () {
      const data = {
        userId: this.user.id,
        profileId: this.user.profile.id
      }

      this.$store.dispatch('updateUserInfo', data)
    },
    leavePage () {
      this.$store.dispatch('closeUserUpdateModal')
      this.$router.push({ path: '/user/list' })
    },
    goBack () {
      window.history.length > 2 ? this.$router.go(-1) : this.$router.push('/')
    },
    closeModal () {
      this.$store.dispatch('closeUserUpdateModal')
    },

    updateAvatar (file) {
      this.$store.dispatch('updateUserAvatar', file)
    },
    updateName (value) {
      this.$store.dispatch('updateUserName', value)
    },
    updateSurname (value) {
      this.$store.dispatch('updateUserSurname', value)
    },
    updatePatronymic (value) {
      this.$store.dispatch('updateUserPatronymic', value)
    },
    updatePhone (value) {
      this.$store.dispatch('updateUserPhone', value)
    },
    updateEmail (value) {
      this.$store.dispatch('updateUserEmail', value)
    },
    updatePassword (value) {
      this.$store.dispatch('updateUserPassword', value)
    },
    addRole (role) {
      this.$store.dispatch('addUserRole', role)
    },
    removeRole (role) {
      this.$store.dispatch('removeUserRole', role)
    },
    updateBirthDate (value) {
      this.$store.dispatch('updateUserBirthDate', value)
    },
    updateCorpPhone (value) {
      this.$store.dispatch('updateUserCorpPhone', value)
    },
    updateWorkPhone (value) {
      this.$store.dispatch('updateUserWorkPhone', value)
    },
    updateWorkPhoneAppend (value) {
      this.$store.dispatch('updateUserWorkPhoneAppend', value)
    },
    updateOfficialFlag () {
      this.$store.dispatch('updateUserOfficialFlag')
    },
    updateStatus (status) {
      this.$store.dispatch('updateUserStatus', status)
    },
    updateDepartment (department) {
      this.$store.dispatch('updateUserDepartment', department)
    },
    updatePosition (position) {
      this.$store.dispatch('updateUserPosition', position)
    },
    updateEmployment (employment) {
      this.$store.dispatch('updateUserEmployment', employment)
    },
    updateEmploymentDate (value) {
      this.$store.dispatch('updateUserEmploymentDate', value)
    },
    updateSchedule (schedule) {
      this.$store.dispatch('updateUserSchedule', schedule)
    },
    updateBirthPlace (place) {
      this.$store.dispatch('updateUserBirthPlace', place)
    },
    updateInn (inn) {
      this.$store.dispatch('updateUserInn', inn)
    },
    updateSnils (snils) {
      this.$store.dispatch('updateUserSnils', snils)
    },
    showFamilyMemberUpdateModal (member) {
      this.$store.dispatch('showUserFamilyMemberUpdateModal', member)
    },
    closeFamilyMemberUpdateModal () {
      this.$store.dispatch('closeUserFamilyMemberUpdateModal')
    },
    removeFamilyMember (memberId) {
      this.$store.dispatch('removeUserFamilyMember', memberId)
    },
    showFamilyMemberCreateModal () {
      this.$store.dispatch('showUserFamilyMemberCreateModal')
    },
    closeFamilyMemberCreateModal () {
      this.$store.dispatch('closeUserFamilyMemberCreateModal')
    },
    showDocumentUpdateModal (document) {
      this.$store.dispatch('showUserDocumentUpdateModal', document)
    },
    closeDocumentUpdateModal () {
      this.$store.dispatch('closeUserDocumentUpdateModal')
    },
    removeDocument (documentId) {
      this.$store.dispatch('removeUserDocument', documentId)
    },
    showDocumentCreateModal () {
      this.$store.dispatch('showUserDocumentCreateModal')
    },
    closeDocumentCreateModal () {
      this.$store.dispatch('closeUserDocumentCreateModal')
    },
    showEducationUpdateModal (education) {
      this.$store.dispatch('showUserEducationUpdateModal', education)
    },
    closeEducationUpdateModal () {
      this.$store.dispatch('closeUserEducationUpdateModal')
    },
    removeEducation (educationId) {
      this.$store.dispatch('removeUserEducation', educationId)
    },
    showEducationCreateModal () {
      this.$store.dispatch('showUserEducationCreateModal')
    },
    closeEducationCreateModal () {
      this.$store.dispatch('closeUserEducationCreateModal')
    }
  },
  mounted () {
    this.loadOptions()

    const userId = this.$route.params.id
    this.$store.dispatch('getUserById', userId)
  },
  // обновляем данные в компоненте, после смены маршрута (для случаев когда находясь в этом же компоненте меняем
  // маршрут на редактирование другого пользователя)
  beforeRouteUpdate (to, from, next) {
    const userId = to.params.id
    this.$store.dispatch('getUserById', userId)
    next()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.user-card {
  display: flex;
  align-items: center;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  width: 254px;
  height: 84px;
  padding-right: 18px;
  padding-left: 22px;
  margin-right: 16px;
  margin-bottom: 16px;

  &__info {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-right: 10px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row nowrap;
    margin-left: auto;
  }

  &__button {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &:last-child {
    margin-right: 0;
  }
}

.card-button {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .3s;
  cursor: pointer;
  color: $font_color_alt;
  background: $color_fourth;
  background: $color_fourth_gradient;
  border: none;

  &__icon {
    margin-right: 10px;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.22);
  }
}

@media screen and (max-width: 576px) {
  .page__buttons {
    margin-bottom: 40px;
  }
}
</style>
